document.addEventListener('DOMContentLoaded', () => {
    const items1 = document.querySelectorAll('#image-container-sx .inner-img');
    const items2 = document.querySelectorAll('#image-container-dx .inner-img');
    const smallItems = document.querySelectorAll('#small-image .inner-img');

    let currentIndex = 0;

    const showNextImage = () => {
        const nextIndex = (currentIndex + 1) % items1.length;

        // Sposta le immagini e i video nella colonna sinistra verso l'alto
        items1.forEach((item, index) => {
            item.style.transform = `translateY(${(index - currentIndex) * 100}%)`;
        });

        // Sposta le immagini e i video nella colonna destra verso il basso
        items2.forEach((item, index) => {
            item.style.transform = `translateY(${(index - currentIndex) * -100}%)`;
        });

        // Sposta l'immagine e il video centrale da destra a sinistra
        smallItems.forEach((item, index) => {
            item.style.transform = `translateX(${(index - currentIndex) * 100}%)`;
        });

        // Aggiorna l'indice corrente
        currentIndex = nextIndex;
    };

    setInterval(showNextImage, 4000);

    // Mostra il primo elemento all'inizio
    showNextImage();
});

